module.exports = __webpack_public_path__ + "img/svg/lock.0378b343abc66a284debc8aaac3926e5.svg";